const ITERABLE_EMAIL_COOKIE = 'iterableEndUserId';
const ITERABLE_EMAIL_ALLBIRDS_ID_QUERY_PARAM = 'allbirds_id';
const ITERABLE_EMAIL_USER_ID_QUERY_PARAM = 'id';
const ITERABLE_EMAIL_CAMPAIGN_ID_QUERY_PARAM = 'Iterable_campaign';
const ITERABLE_EMAIL_TEMPLATE_ID_QUERY_PARAM = 'Iterable_template';

export {
  ITERABLE_EMAIL_COOKIE,
  ITERABLE_EMAIL_ALLBIRDS_ID_QUERY_PARAM,
  ITERABLE_EMAIL_CAMPAIGN_ID_QUERY_PARAM,
  ITERABLE_EMAIL_TEMPLATE_ID_QUERY_PARAM,
  ITERABLE_EMAIL_USER_ID_QUERY_PARAM,
};
